import { defineStore } from "pinia";
import gql from "graphql-tag";
import { Preferences } from "@capacitor/preferences";
import { apolloClient } from "@/vue-apollo";
import { presentToastWithOptions } from "@/utils/functions";
import {
  BLOCKED_BY_USERS,
  BLOCKED_USERS,
  CREATE_BLOCKED_USER,
  DELETE_BLOCKED_USER,
  GLAMSQUADS,
} from "../graphql_queries";
import { ACTIVITIES } from "../graphql_queries/user-activity.gql";
import { REVIEW_TYPE } from "@/utils/constants";
import { signInWithFacebook, signInWithGoogle } from "@/helper/firebaseAuthLib";
import {
  getAuth,
  FacebookAuthProvider,
  signInWithCredential,
  OAuthProvider,
} from "firebase/auth";

export const useUserStore = defineStore("userStore", {
  state: () => ({
    isAuthenticated: false,
    isLoading: false,
    error: null,
    user: <any>{
      profile: {
        id: "",
        bgBanner: "",
        state: "",
        city: "",
        country: "",
        summary: "",
        skintype: "",
        hairtype: "",
        eyecolor: "",
        bio: "",
        nickName: "",
      },
      role: "",
      id: "",
      avatar: "",
      firstName: "",
      lastName: "",
      mobile: "",
      email: "",
      nickName: "",
      isPrivate: false,
      userName: "",
      followersCount: 0,
      followingCount: 0,
      products: <any>[],
      reviews: <any>[],
    },
    glamSquads: <any>[],
    userid: "",
    otherUser: <any>null,
    authChecked: false,
    token: "",
    requests: [],
    tribeUsers: <any>[],
    friends: [],
    isCode: false,
    sendEmail: "",
    resetCode: "",
    editedProfile: false,
    followers: <any>[],
    followings: <any>[],
    blockedUsers: <any>[],
    blockedByUsers: <any>[],
    userActivities: <any>[],
  }),
  actions: {
    async emailExists(email: string) {
      const response = await apolloClient.query({
        variables: {
          email,
        },
        query: gql`
          query emailExists($email: String!) {
            emailExists(email: $email) {
              result
              msg
            }
          }
        `,
        fetchPolicy: "network-only",
      });

      if (response.data.emailExists.result === "success") {
        // dispatch("ax")
        return true;
      } else {
        return false;
      }
    },

    async nicknameExists(nickname: string) {
      const response = await apolloClient.query({
        variables: {
          nickname,
        },
        query: gql`
          query nicknameExists($nickname: String!) {
            nicknameExists(nickname: $nickname) {
              result
              msg
            }
          }
        `,
        fetchPolicy: "network-only",
      });

      if (response.data.nicknameExists.result === "success") {
        // dispatch("ax")
        return true;
      } else {
        return false;
      }
    },

    async axCreateOrFindFirebaseUser(
      { displayName, email, photoUrl, uid, emailVerified, profile, role }: any,
      password?: string
    ) {
      this.isLoading = true;

      const response = await apolloClient.mutate({
        variables: {
          data: {
            displayName,
            email,
            photoUrl,
            uid,
            emailVerified,
            profile,
            password,
            role
          },
        },
        mutation: gql`
          mutation createOrFindFirebaseUser($data: FirebaseUserInput!) {
            createOrFindFirebaseUser(data: $data) {
              status
              token
              isNewUser
              user {
                id
                firstName
                lastName
                mobile
                email
                status
                avatar
                isPrivate
                role
                profile {
                  id
                  nickName
                  summary
                  bgBanner
                  country
                  state
                  city
                  hair
                  skin
                  eye
                }
                following {
                  id
                  toUser {
                    id
                  }
                }
              }
            }
          }
        `,
        fetchPolicy: "network-only",
      });

      const { status, token, user, isNewUser } =
        response.data.createOrFindFirebaseUser;

      this.isLoading = false;
      console.log("g-token===>", token);
      if (response.data.createOrFindFirebaseUser.status === "success") {
        const token = response.data.createOrFindFirebaseUser.token;
        const userdata: string = JSON.stringify(
          response.data.createOrFindFirebaseUser.user
        );
        this.user = user;
        await Preferences.set({ key: "user", value: userdata });

        if (token.split(".")[1])
          await Preferences.set({ key: "accessToken", value: token });
        return { success: true, isNewUser };
      } else {
        await Preferences.remove({ key: "accessToken" });
        return false;
      }
    },

    async axSignupUser({ email, password, profile }: any) {
      console.log("email, password profile===>", email, password, profile);
      this.isLoading = true;
      try {
        const response = await apolloClient.mutate({
          variables: {
            data: { email, password, profile },
          },
          mutation: gql`
            mutation createUser($data: UserInput) {
              createUser(data: $data) {
                id
              }
            }
          `,
          fetchPolicy: "network-only",
        });

        console.log("resCreateUser===>", response);
        if (response.data.createUser.id) {
          this.isLoading = false;
          return true;
        } else {
          this.isLoading = false;
          return false;
        }
      } catch (error) {
        this.isLoading = false;
        presentToastWithOptions(
          "Signup Failed. There is a problem with the server.",
          "danger"
        );
      }
    },

    async axGoogleLogin() {
      this.isLoading = false;
      try {
        const res: any = await signInWithGoogle();
        console.log("resGoogle==>", res?.uid);
        if (res?.uid) {
          console.log(
            "Full Google SignIn result:",
            JSON.stringify(res, null, 2)
          );
          console.log(
            "Data being sent to GraphQL:",
            JSON.stringify({ ...res, profile: { nickName: "" } }, null, 2)
          );
          const response: any = await this.axCreateOrFindFirebaseUser({
            ...res,
            profile: { nickName: "" },
          });
          if (response) {
            return response; // return { success, isNewUser }
          } else {
            return { success: false };
          }
        } else {
          this.user = null;
          this.token = "";
          return { success: false };
        }
      } catch (error) {
        this.user = null;
        this.token = "";
        console.log("googleError===>", error);
        return { success: false };
      }
    },

    async axFbLogin(fbToken: string) {
      console.log("fb login with token", fbToken);
      this.isLoading = true;
      const auth = getAuth();

      try {
        // Create Firebase credential with Facebook token
        const credential = FacebookAuthProvider.credential(fbToken);

        // Sign in to Firebase with credential
        const userCredential = await signInWithCredential(auth, credential);
        const user = userCredential.user;

        console.log("Firebase user:", user);

        if (!user?.uid) {
          this.user = null;
          this.token = "";
          this.isLoading = false;
          return { success: false };
        }

        // Use user info to create/find user in your backend/local DB
        const response = await this.axCreateOrFindFirebaseUser({
          uid: user.uid,
          email: user.email,
          displayName: user.displayName,
          photoURL: user.photoURL,
          profile: { nickName: "" },
        });

        this.isLoading = false;

        if (response) {
          console.log(response);
          return response; // { success, isNewUser }
        } else {
          return { success: false };
        }
      } catch (error: any) {
        this.isLoading = false;
        this.user = null;
        this.token = "";
        if (error.code === "auth/account-exists-with-different-credential") {
          const email = error.customData.email;
          const pendingCred = error.credential;
          console.log("Email:", email);
          console.log("Pending Credential:", pendingCred);

          // Here you can prompt the user to sign in with one of those providers
          // and then link the Facebook credential:
          // Example: if 'google.com' is in providers, ask user to sign in with Google first,
          // then link Facebook credential with linkWithCredential()
        } else {
          console.error("Firebase signInWithCredential error:", error);
        }
        return { success: false };
      }
    },
    async axAppleLogin(
      identityToken: string,
      nonce: string,
      givenName: string | null,
      familyName: string | null
    ) {
      console.log("Apple login with token", identityToken);
      this.isLoading = true;
      const auth = getAuth();

      try {
        const provider = new OAuthProvider("apple.com");

        // Build Apple OAuth credential
        const credential = provider.credential({
          idToken: identityToken,
          rawNonce: nonce,
        });

        // Sign in to Firebase
        const userCredential = await signInWithCredential(auth, credential);
        const user = userCredential.user;

        console.log("Firebase user:", user);

        if (!user?.uid) {
          this.user = null;
          this.token = "";
          this.isLoading = false;
          return { success: false };
        }

        // ✅ Get Firebase ID token
        const idToken = await user.getIdToken();

        // ✅ Save token in store
        this.token = idToken;
        this.user = user; // Optional, if you want to keep Firebase user info

        // ✅ Optionally persist it
        await Preferences.set({ key: "accessToken", value: idToken });
        // Use user info to create/find user in your backend
        const response = await this.axCreateOrFindFirebaseUser({
          uid: user.uid,
          email: user.email,
          displayName:
            user.displayName ||
            [givenName, familyName].filter(Boolean).join(" "),
          photoURL: user.photoURL,
          profile: { nickName: "" },
        });

        this.isLoading = false;

        if (response) {
          console.log("Backend response", response);
          return response;
        } else {
          return { success: false };
        }
      } catch (error: any) {
        this.isLoading = false;
        this.user = null;
        this.token = "";

        if (error.code === "auth/account-exists-with-different-credential") {
          console.warn("Account exists with different credential", error);
        } else {
          console.error("Apple login error", error);
        }

        return { success: false };
      }
    },
    async axUpdateUser(id: string, data: any) {
      console.log("id, data: ", id, data);

      const response = await apolloClient.mutate({
        variables: {
          id,
          data,
        },
        mutation: gql`
          mutation updateUser($id: String, $data: UserInput) {
            updateUser(id: $id, data: $data) {
              id
              firstName
              lastName
              mobile
              email
              avatar
              role
              isPrivate
              status
            }
          }
        `,
        fetchPolicy: "network-only",
      });

      console.log("resUpdateUser===>", response);
      if (response.data.updateUser.id) {
        this.editedProfile = true;
        this.checkAuth(this.token);
        return true;
      } else {
        return false;
      }
    },
    async axUpdateUserProfile(id: string, data: any) {
      console.log("id, data: ", id, data);

      const response = await apolloClient.mutate({
        variables: {
          id,
          data,
        },
        mutation: gql`
          mutation updateUserProfile($id: String, $data: ProfileInput) {
            updateUserProfile(id: $id, data: $data) {
              id
              firstName
              lastName
              mobile
              email
              avatar
              role
              isPrivate
              status
            }
          }
        `,
        fetchPolicy: "network-only",
      });

      console.log("resUpdateUser===>", response);
      if (response.data.updateUserProfile.id) {
        this.editedProfile = true;
        this.checkAuth(this.token);
        return true;
      } else {
        return false;
      }
    },

    async axLoginUser(email: string, password: string) {
      this.isLoading = true;
      try {
        const response = await apolloClient.query({
          variables: {
            email,
            password,
          },
          query: gql`
            query userLogin($email: String!, $password: String!) {
              userLogin(email: $email, password: $password) {
                status
                token
                user {
                  id
                  firstName
                  lastName
                  mobile
                  email
                  status
                  avatar
                  role
                  isPrivate
                  profile {
                    id
                    nickName
                    summary
                    bgBanner
                    country
                    state
                    city
                    hair
                    skin
                    eye
                  }
                  following {
                    id
                    toUser {
                      id
                    }
                  }
                }
              }
            }
          `,
          fetchPolicy: "network-only",
        });

        console.log(response.data);
        this.isLoading = false;
        const { status, token, user, isNewUser } =
          response.data.createOrFindFirebaseUser;
        if (response.data.userLogin.status === "success") {
          const token = response.data.userLogin.token;
          const userdata: string = JSON.stringify(response.data.userLogin.user);
          this.user = response.data.userLogin.user;
          await Preferences.set({ key: "user", value: userdata });

          if (token.split(".")[1])
            await Preferences.set({ key: "accessToken", value: token });

          return { success: true, isNewUser };
        } else {
          await Preferences.remove({ key: "accessToken" });
          return { success: false };
        }
      } catch (error) {
        console.log(error);
        this.isLoading = false;
        return false;
      }
    },

    async checkAuth(token: string) {
      try {
        const response = await apolloClient.query({
          variables: {
            token,
          },
          query: gql`
            query checkToken($token: String!) {
              checkToken(token: $token) {
                status
                token
                user {
                  id
                  firstName
                  lastName
                  mobile
                  email
                  status
                  avatar
                  role
                  isPrivate
                  profile {
                    id
                    nickName
                    summary
                    bgBanner
                    country
                    state
                    city
                    hair
                    skin
                    eye
                  }
                  following {
                    id
                    toUser {
                      id
                    }
                  }
                }
              }
            }
          `,
          fetchPolicy: "network-only",
        });

        if (response.data.checkToken.status === "success") {
          this.token = response.data.checkToken.token;
          this.user = response.data.checkToken.user;
          await Preferences.set({ key: "accessToken", value: this.token });
          return true;
        } else {
          this.token = "";
          this.user = null;
          await Preferences.remove({ key: "accessToken" });
          return false;
        }
      } catch (error) {
        this.token = "";
        this.user = null;
        await Preferences.remove({ key: "accessToken" });
        return false;
      }
    },

    async axDeleteUser(id: string) {
      const response = await apolloClient.mutate({
        variables: {
          id,
        },
        mutation: gql`
          mutation deleteUser($id: String) {
            deleteUser(id: $id)
          }
        `,
        fetchPolicy: "network-only",
      });

      console.log("resDeleteUser===>", response);
      if (response.data.deleteUser === "success") {
        return true;
      } else {
        return false;
      }
    },

    async sendForgotPasswordEmail(email: string) {
      const response = await apolloClient.query({
        variables: {
          email,
        },
        query: gql`
          query sendForgotPasswordEmail($email: String!) {
            sendForgotPasswordEmail(email: $email) {
              result
              msg
            }
          }
        `,
        fetchPolicy: "network-only",
      });

      const res = response.data.sendForgotPasswordEmail;
      if (response.data.sendForgotPasswordEmail.result === "success") {
        this.isCode = true;
        this.sendEmail = email;
        return res;
      } else {
        this.sendEmail = "";
        this.isCode = false;
        return res;
      }
    },

    async sendForgotPasswordCode({ email, code }: any) {
      const response = await apolloClient.query({
        variables: {
          data: { email, code },
        },
        query: gql`
          query sendForgotPasswordCode($data: ForgotPasswordInput!) {
            sendForgotPasswordCode(data: $data) {
              result
              msg
            }
          }
        `,
        fetchPolicy: "network-only",
      });

      const res = response.data.sendForgotPasswordCode;
      if (response.data.sendForgotPasswordCode.result === "success") {
        this.isCode = true;
        this.sendEmail = email;
        this.resetCode = code;
      } else {
        this.isCode = false;
        this.sendEmail = "";
        this.resetCode = "";
      }
      return res;
    },

    async resetPassword({ email, code, password }: any) {
      const response = await apolloClient.query({
        variables: {
          data: { email, code, password },
        },
        query: gql`
          query resetPassword($data: ForgotPasswordInput!) {
            resetPassword(data: $data) {
              result
              msg
            }
          }
        `,
        fetchPolicy: "network-only",
      });

      const res = response.data.resetPassword;
      this.isCode = false;
      this.sendEmail = "";
      this.resetCode = "";
      return res;
    },

    async axChangePassword(id: string, data: any) {
      const response = await apolloClient.query({
        variables: {
          id,
          data,
        },
        query: gql`
          query changePassword($id: String!, $data: ChangePasswordInput!) {
            changePassword(id: $id, data: $data) {
              status
              token
              user {
                id
                firstName
                lastName
                mobile
                email
                status
                avatar
                role
                profile {
                  nickName
                  summary
                  bgBanner
                  country
                  state
                  city
                  hair
                  skin
                  eye
                }
              }
            }
          }
        `,
        fetchPolicy: "network-only",
      });

      if (response.data.changePassword.status === "success") {
        return true;
      } else {
        return false;
      }
    },

    async axOtherUser(id: string) {
      this.isLoading = true;
      const response = await apolloClient.query({
        variables: {
          id,
        },
        query: gql`
          query user($id: String!) {
            user(id: $id) {
              id
              email
              firstName
              lastName
              mobile
              avatar
              role
              isPrivate
              status
              reviews {
                id
                type
                title
                description
                rating
                updatedAt
                product {
                  id
                  title
                  url
                }
                brand {
                  id
                  name
                  logo
                }
                event {
                  id
                  title
                  logo
                }
              }
              profile {
                id
                nickName
                title
                summary
                city
                state
                country
                bgBanner
                eye
                skin
                hair
              }
            }
          }
        `,
        fetchPolicy: "network-only",
      });
      console.log(response.data.user, "USEER");
      if (response.data.user?.id) {
        this.otherUser = response.data.user;
        this.isLoading = false;
        return true;
      } else {
        this.otherUser = null;
        this.isLoading = false;
        return false;
      }
    },

    async axFollows(id: string) {
      this.isLoading = true;
      const response = await apolloClient.query({
        variables: {
          userId: id,
        },
        query: gql`
          query userFollowsByUserId($userId: String!) {
            userFollowsByUserId(userId: $userId) {
              followers {
                id
                status
                fromUser {
                  id
                  email
                  firstName
                  lastName
                  avatar
                  profile {
                    nickName
                  }
                }
                toUser {
                  id
                  email
                  firstName
                  lastName
                  avatar
                  profile {
                    nickName
                  }
                }
              }
              followings {
                id
                status
                fromUser {
                  id
                  email
                  firstName
                  lastName
                  avatar
                  profile {
                    nickName
                  }
                }
                toUser {
                  id
                  email
                  firstName
                  lastName
                  avatar
                  profile {
                    nickName
                  }
                }
              }
            }
          }
        `,
        fetchPolicy: "network-only",
      });

      if (response.data.userFollowsByUserId) {
        this.isLoading = false;
        this.followers = response.data.userFollowsByUserId.followers;
        this.followings = response.data.userFollowsByUserId.followings;
        return true;
      } else {
        this.followers = [];
        this.followings = [];
        this.isLoading = false;
        return false;
      }
    },

    async axLogout() {
      this.token = "";
      this.user = null;
      await Preferences.remove({ key: "accessToken" });
      await Preferences.remove({ key: "user" });
      await Preferences.remove({ key: "token" });
    },

    async axGetRequests(id: any) {
      const response = await apolloClient.query({
        variables: {
          id,
        },
        query: gql`
          query getRequests($id: String!) {
            getRequests(id: $id) {
              id
              status
            }
          }
        `,
        fetchPolicy: "network-only",
      });

      if (response.data.getRequests) {
        return true;
      } else {
        return false;
      }
    },

    async axCreateUserFollow(data: any) {
      const response = await apolloClient.mutate({
        variables: {
          data,
        },
        mutation: gql`
          mutation createUserFollow($data: UserFollowInput) {
            createUserFollow(data: $data) {
              id
            }
          }
        `,
        fetchPolicy: "network-only",
      });

      if (response.data.createUserFollow.id) {
        return true;
      } else {
        return false;
      }
    },

    async axUpdateUserFollow(id: string, data: any) {
      const response = await apolloClient.mutate({
        variables: {
          id,
          data,
        },
        mutation: gql`
          mutation updateUserFollow($id: String!, $data: UserFollowInput) {
            updateUserFollow(id: $id, data: $data) {
              id
            }
          }
        `,
        fetchPolicy: "network-only",
      });

      if (response.data.updateUserFollow.id) {
        return true;
      } else {
        return false;
      }
    },

    async axDeleteUserFollow(data: any) {
      const response = await apolloClient.mutate({
        variables: {
          data,
        },
        mutation: gql`
          mutation deleteUserFollow($data: UserFollowInput!) {
            deleteUserFollow(data: $data)
          }
        `,
        fetchPolicy: "network-only",
      });

      if (response.data.deleteUserFollow === "success") {
        return true;
      } else {
        return false;
      }
    },

    async axBlockedUsers(userId?: string, searchVal?: string) {
      this.isLoading = true;
      try {
        const response = await apolloClient.query({
          variables: {
            userId,
            searchVal,
          },
          query: BLOCKED_USERS,
          fetchPolicy: "network-only",
        });

        if (response.data.blockedUsers) {
          this.isLoading = false;
          this.blockedUsers = response.data.blockedUsers;
          return true;
        } else {
          this.blockedUsers = [];
          this.isLoading = false;
          return false;
        }
      } catch (error) {
        this.blockedUsers = [];
        this.isLoading = false;
        return false;
      }
    },

    async axBlockedByUsers(userId?: string) {
      this.isLoading = true;
      try {
        const response = await apolloClient.query({
          variables: {
            userId,
          },
          query: BLOCKED_BY_USERS,
          fetchPolicy: "network-only",
        });

        if (response.data.blockedByUsers) {
          this.isLoading = false;
          this.blockedByUsers = response.data.blockedByUsers;
          return true;
        } else {
          this.blockedByUsers = [];
          this.isLoading = false;
          return false;
        }
      } catch (error) {
        this.blockedByUsers = [];
        this.isLoading = false;
        return false;
      }
    },

    async axCreateBlockedUser(data: any) {
      try {
        const response = await apolloClient.mutate({
          variables: {
            data,
          },
          mutation: CREATE_BLOCKED_USER,
          fetchPolicy: "network-only",
        });

        if (response.data.createBlockedUser?.id) {
          return true;
        } else {
          return false;
        }
      } catch (error) {
        return false;
      }
    },

    async axDeleteBlockedUser(id: any) {
      try {
        const response = await apolloClient.mutate({
          variables: {
            id,
          },
          mutation: DELETE_BLOCKED_USER,
          fetchPolicy: "network-only",
        });

        if (response.data.deleteBlockedUser === "success") {
          return true;
        } else {
          return false;
        }
      } catch (error) {
        return false;
      }
    },

    async axTribeSuggestions(query = "") {
      const response = await apolloClient.query({
        variables: {
          query,
        },
        query: gql`
          query users($query: String) {
            users(query: $query) {
              id
              firstName
              lastName
              followerCount
              avatar
              fullname
              profile {
                nickName
                summary
                city
                state
                country
              }
            }
          }
        `,
        fetchPolicy: "network-only",
      });

      if (response.data.users) {
        this.tribeUsers = response.data.users;

        return true;
      } else {
        return false;
      }
    },

    async axUserGlamSquads(userId: string) {
      // const userId = this.user.id
      const response = await apolloClient.query({
        variables: {
          userId,
        },
        query: GLAMSQUADS,
        fetchPolicy: "network-only",
      });

      if (response.data.userGlamSquadMembers) {
        this.glamSquads = response.data.userGlamSquadMembers;
        console.log("1", response.data.userGlamSquadMembers);

        return true;
      } else {
        console.log("2");

        return false;
      }
    },

    async axCommunityFeeds(userId: string) {
      const response = await apolloClient.query({
        variables: {
          userId,
        },
        query: ACTIVITIES,
        fetchPolicy: "network-only",
      });

      if (response.data.userActivities) {
        this.userActivities = response.data.userActivities;

        return true;
      } else {
        console.log("2");

        return false;
      }
    },
  },
  //
  // GETTERS
  //
  getters: {
    loggedIn: (state: { user: any }) => {
      return state.user ? true : false;
    },
    authError: (state: { error: any }) => {
      return state.error;
    },
    getToken: (state: { token: string }) => {
      return state.token;
    },

    getFollowingCount: (state: { followings: any }) => {
      return state.followings.filter((item: any) => item.status === "active")
        .length;
    },

    getFollowerCount: (state: { followers: any }) => {
      return state.followers.filter((item: any) => item.status === "active")
        .length;
    },
    getReviewCount: (state: { otherUser: any }) => {
      return state.otherUser && state.otherUser.reviews
        ? state.otherUser.reviews.length
        : 0;
    },

    getIsFollowing: (state: { followers: any; user: any }) => {
      return state.followers.some(
        (item: any) =>
          item.fromUser?.id === state.user?.id && item.status === "active"
      );
    },

    getReviews: (state: { otherUser: any }) => {
      const reviews = state.otherUser?.reviews || [];
      if (reviews.length > 0) {
        const tempArr = reviews.map((review: any) => {
          const tempReview = { ...review };
          console.log({ tempReview: review });
          let object: any = null;
          if (review?.type === REVIEW_TYPE.BRAND) {
            const { id, name, logo } = review?.brand || {};
            object = review?.brand ? { id, title: name, image: logo } : null;
          } else if (review?.type === REVIEW_TYPE.PRODUCT) {
            const { id, title, url } = review?.product || {};
            object = review?.product ? { id, title, image: url } : null;
          } else if (review?.type === REVIEW_TYPE.EVENT) {
            const { id, title, logo } = review?.event || {};
            object = review?.event ? { id, title, image: logo } : null;
          } else {
            object = null;
          }
          delete tempReview?.brand;
          delete tempReview?.event;
          delete tempReview?.product;
          return { ...tempReview, object };
        });
        return tempArr;
      } else {
        return [];
      }
    },

    getTribes: (state) => {
      const followings = state.user?.following?.map(
        (item: any) => item?.toUser?.id
      );
      const removeUsers = [state.user.id, ...followings];
      const filters = state.tribeUsers.filter(
        (item: any) => !removeUsers.includes(item.id)
      );
      return filters;
    },

    getSquadTribes: (state) => {
      const squads = state.glamSquads.map((item: any) => item.member.id);
      const removeUsers = [state.user.id, ...squads];
      const filters = state.tribeUsers.filter(
        (item: any) => !removeUsers.includes(item.id)
      );
      return filters;
    },

    getBlockedByUsers: (state) => {
      return state.blockedByUsers.map((item: any) => item?.blockedBy?.id);
    },

    getUnblockedUsers: (state) => {
      const blocks = state.blockedUsers.map(
        (item: any) => item?.blockedUser?.id
      );
      const removeblockedUsers = [state.user.id, ...blocks];
      const filters = state.tribeUsers.filter(
        (item: any) => !removeblockedUsers.includes(item.id)
      );
      return filters;
    },
  },
});
